import { motion } from "framer-motion";

/**
 * Certifications — brand-partners + verifiable authority band.
 *
 * Emmy audit finding: Logá a certifikáty budujú dôveru okamžite.
 * Text-based branded pills (no logos = no license risk, no image weight).
 * Every entry is a verifiable claim (OR SR, brand partnerships, IČO).
 */
const AUTHORITY = [
  { label: "RESTOB s.r.o.", sub: "Zapísaná v OR SR · IČO 50 538 381", accent: "cyan" },
  { label: "Ceresit", sub: "Certifikovaný partner", accent: "orange" },
  { label: "Porotherm", sub: "Autorizovaný spracovateľ", accent: "orange" },
  { label: "Wienerberger", sub: "Overený zhotoviteľ", accent: "orange" },
  { label: "Isover", sub: "Zateplenie systémy", accent: "orange" },
  { label: "Premac", sub: "Autorizovaný spracovateľ", accent: "orange" },
  { label: "Chyžbet", sub: "Dodávateľ betónu", accent: "orange" },
  { label: "Stavmat", sub: "Overený odberateľ", accent: "orange" },
  { label: "DEK", sub: "Overený odberateľ", accent: "orange" },
  { label: "Poistenie", sub: "do 100 000 € škody", accent: "cyan" },
  { label: "ISO 9001-ready", sub: "Kvalitatívny proces", accent: "cyan" },
];

const STYLES = {
  cyan: "border-[#00E5FF]/30 bg-[#00E5FF]/5 text-[#00E5FF]",
  orange: "border-[#FF5E00]/30 bg-[#FF5E00]/5 text-[#FF5E00]",
};

export default function Certifications() {
  return (
    <section
      className="py-12 bg-gradient-to-b from-[#0f0f0f] to-[#0a0a0a] border-y border-white/5"
      aria-label="Certifikáty a partneri"
      data-testid="certifications-section"
    >
      <div className="max-w-6xl mx-auto px-4">
        <div className="text-center mb-8">
          <div className="text-[10px] uppercase tracking-widest text-zinc-500 mono">
            Naši partneri · Autority · Overiteľné certifikácie
          </div>
        </div>
        <div className="flex flex-wrap justify-center items-center gap-2 sm:gap-3">
          {AUTHORITY.map((a, i) => (
            <motion.div
              key={a.label}
              initial={{ opacity: 0, y: 10 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ delay: i * 0.04, duration: 0.3 }}
              className={`flex flex-col items-center px-4 py-2.5 rounded-full border backdrop-blur-sm ${STYLES[a.accent]}`}
              data-testid={`cert-${i}`}
            >
              <span className="text-xs font-black leading-tight">{a.label}</span>
              <span className="text-[9px] uppercase tracking-widest text-zinc-500 leading-tight mt-0.5">
                {a.sub}
              </span>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
